import { ThemeProvider, ToastProvider } from '@hooks';
import { MediaQuerySubscription } from '@layout/navigation/MediaQuerySubscription/MediaQuerySubscription';
import { createEmotionCache, MantineProvider } from '@mantine/core';
import {
  createTheme,
  ThemeProvider as MUIThemeProvider,
} from '@material-ui/core';
import { BTheme, Elevation2 } from '@services/mantine';
import { reduxPersistor, reduxStore } from '@store';
import { GlobalStyles } from '@styles';
import '@styles/global/global.scss';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/slide.css';
import 'antd/dist/antd.css';
import { QueryClient, QueryClientProvider } from 'react-query';
import { Provider as ReduxProvider } from 'react-redux';
import { PersistGate } from 'redux-persist/integration/react';
import { Routes } from './routes';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});
const defaultTheme = createTheme();

defaultTheme.shadows[8] = Elevation2.boxShadow as string;
const theme = createTheme({
  palette: {
    primary: {
      main: '#1371FE',
    },
  },
  typography: {
    fontFamily: "'Poppins', sans-serif",
  },
  shadows: defaultTheme.shadows,
});

const myCache = createEmotionCache({ key: 'mantine' });
const App = () => {
  return (
    <MantineProvider theme={BTheme} emotionCache={myCache}>
      <MUIThemeProvider theme={theme}>
        <ThemeProvider>
          <GlobalStyles />
          <ToastProvider />
          <QueryClientProvider client={queryClient}>
            <ReduxProvider store={reduxStore}>
              <PersistGate persistor={reduxPersistor}>
                <MediaQuerySubscription />
                <Routes />
              </PersistGate>
            </ReduxProvider>
          </QueryClientProvider>
        </ThemeProvider>
      </MUIThemeProvider>
    </MantineProvider>
  );
};

export default App;
